import React, { useEffect, useState } from 'react'
import { SelectMultistore } from '../../components/select-multistore/select-multistore.component';
import { useStore } from '../../providers/store.provider';
import { SettingsComponent } from './SettingsComponent';

const SettingsPage = (props) => {

    const storeProvider = useStore();

    const [isMultistore, setIsMultistore] = useState(storeProvider.getMultistoreState());

    const selectedMultistore = storeProvider.selectedMultistore?.id;

    useEffect(() => {
        setIsMultistore(storeProvider.getMultistoreState())
    }, [storeProvider])

    return (
        (!isMultistore || !(isMultistore && !selectedMultistore)) ? (
            <SettingsComponent storeId={selectedMultistore} />
        ) :
            (
                <SelectMultistore />
            )
    )

}

export default SettingsPage
